<div class="search-waterways" scrollable scrollbar="true" [onEndScroll]="searchWaterways">
  <div class="modal-close" (click)="closeModal()"><mat-icon aria-hidden="false">close</mat-icon></div>
  <ul class="search-waterways__content" *ngIf="(filterWaterways$ | async).result as waterways">
    <li *ngFor="let waterway of waterways" class="search-waterways__item">
      <div class="search-waterways__item-content">
        <div>
          <p class="search-waterways__name-item" (click)="navigateWaterway(waterway)">{{waterway.Name}}</p>
          <p class="search-waterways__address-item" *ngIf="waterway.IsPremium">Premium Map</p>
          <p class="search-waterways__address-item">{{waterway.State}}({{waterway.County}})</p>
        </div>
        <div>
          <app-button class="{{ waterway.isConnected ? 'mat-unfollow' : '' }}" (clicked)="handleFollow()">Follow</app-button>
        </div>
      </div>
    </li>
  </ul>
  <div class="search-waterways__not-found" *ngIf="!(filterWaterways$ | async).result && !(filterWaterways$ | async).isLoading">
    <p class="title">No waterways found</p>
    <p class="content">We couldn't find an exact match for. <span>Try these tips:</span></p>
    <ol>
      <li>Check the spelling</li>
      <li>Search by a different alias or name</li>
      <li>Search by a zip code or by a state</li>
      <li>Jump right to the <a href="/fishing-maps">explore map</a> and find the waterway on your own</li>
      <li>
        We might not know about this waterway yet. <a href="/contact">Send us</a> any information you have about the waterway and we'll add
        it as soon as possible
      </li>
    </ol>
  </div>
  <app-spinner [isFetching]="(filterWaterways$ | async).isLoading"></app-spinner>
</div>
